import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';
import { ProfileData, UpdateProfileDto, ProfileStructure } from '../types/profile.types';

class ProfileService {
  async getProfileStructure(): Promise<ProfileStructure> {
    const response = await api.get<ApiResponse<ProfileStructure>>('/users/me/profile-structure');
    return unwrapApiResponse<ProfileStructure>(response);
  }

  async getProfileData(): Promise<ProfileData> {
    const response = await api.get<ApiResponse<ProfileData>>('/users/me');
    return unwrapApiResponse<ProfileData>(response);
  }

  async updateProfileData(data: UpdateProfileDto): Promise<ProfileData> {
    const response = await api.patch<ApiResponse<ProfileData>>('/users/me', data);
    return unwrapApiResponse<ProfileData>(response);
  }
}

export const profileService = new ProfileService();
